
import { AutomaticUserHelpPopup, SessionContext } from "@viamap/viamap2-common";
import { useContext } from "react"
import { WindowDisplayer } from "src/WindowManager/WindowDisplayer";
import { MapStyleSwitch } from "./MapStyleSwitch";

export const MapitButtonsAndOverlays = () => {
  const { state: sessionState } = useContext(SessionContext);

  return (
    <>
      <AutomaticUserHelpPopup
        sessionState={sessionState}
      />
      <WindowDisplayer />
      {/* <QuickOrthoPhoto onOpenStyle={() => {setOpenStyle((e) => !e)}} /> */}
      <MapStyleSwitch />
      {/* <ReturnTo17 /> */}
    </>
  )
}
